import React from 'react';
import { useTranslation } from 'react-i18next';

import DBSLogo from '~/assets/logos/dbs-logo.png';
import { DataTransacton } from '~/entities/schemas/dataTransaction';

import styles from './Footer.module.scss';

interface FooterComponentProps {
  dataTransaction: DataTransacton | null;
  loadingDataTr: boolean;
}

export const FooterComponent: React.FC<FooterComponentProps> = () => {
  const { t } = useTranslation();
  return (
    <footer className={styles.footer}>
      <div className={styles.brand}>
        <img src={DBSLogo} alt="DBS" className={styles.logo} />
        <span className={styles.poweredBy}>{t('footer:poweredBy')}</span>
      </div>
      <div className={styles.contact}>
        <span className={styles.contactLabel}>{t('footer:contact')}</span>
        <a href="mailto:dbs.payment@evisacam.com" className={styles.email}>
          dbs.payment@evisacam.com
        </a>
      </div>
    </footer>
  );
};
